import PropTypes from 'prop-types';
import React, {useState} from 'react';
import PopIn from '../../../common/components/PopIn';
import UpdateComp from '../../../common/components/UpdateComp';
import AdminDetails from './AdminDetails';

const UpdateAdmin = ({admin}) => {
  const [detailsVisible, setDetailsVisible] = useState(false);
  const {firstName, lastName} = admin;

  return (
    <UpdateComp action={() => setDetailsVisible(true)}>

      <PopIn
        title={firstName + ' ' + lastName}
        visible={detailsVisible}
        setModalVisible={setDetailsVisible}
        size={'xl'}
      >
        <AdminDetails admin={admin} setDetailsVisible={setDetailsVisible}/>
      </PopIn>
    </UpdateComp>
  );
};

UpdateAdmin.propTypes = {
  admin: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }).isRequired,
};

export default UpdateAdmin;
